<template>
    <div class="wrap">
        <car-headerbar :title="'分享问卷'" :isCustomLeft="isCustomLeft"/>
        <me-card>
            <template #title>
                <p class="title">分享</p>
            </template>
            <template #content>
                <div class="content">
                    <div class="qrcode-tips">
                        <p>您可以通过以下方式分享问卷</p>
                    </div>
                    <div class="share">
                        <img
                            src="../images/guagua_icon.png"
                            alt="呱呱"
                            @click="shareTo('shareToChatList')">
                        <img
                            src="../images/wechat_icon.png"
                            alt="微信"
                            class="wexin"
                            @click="shareTo('shareToWXFriends')">
                    </div>
                </div>
            </template>
        </me-card>
        <me-card>
            <template #title>
                <p class="title">问卷链接</p>
            </template>
            <template #content>
                <div >
                    <me-field v-model="shareInfo.shareUrl" readonly label="" placeholder="问卷链接" />
                    <div class="operate">
                        <me-button
                            type="default"
                            size="small"
                            :icon="copyIcon"
                            @click="copyUrl(shareInfo.shareUrl)">复制</me-button>
                        <me-button
                            type="default"
                            size="small"
                            :icon="openIcon"
                            @click="turnTo(shareInfo.shareUrl)">打开</me-button>

                    </div>
                </div>
            </template>
        </me-card>
        <me-card>
            <template #title>
                <p class="title">二维码</p>
            </template>
            <template #content>
                <div class="content">
                    <div class="qrcode-tips">
                        <p>长按二维码，保存到手机</p>
                        <!-- <me-button type="default" size="small" @click="copyUrl(shareInfo.shareUrl)">制作二维码海报</me-button> -->
                    </div>
                    <div class="qrcode-img">
                        <img :src="shareInfo.qrCodeUrl" alt="">
                    </div>
                </div>

            </template>
        </me-card>
    </div>
</template>
<script>
import NativeApi from 'native-api'
import { Toast } from '@guazi-fe/melon'
import { Questionnaire } from '@/network'
import { mixin } from '@/mixins'
import copy from '@/util/copy'
import browser from '@/util/browser'
import { off as offStatus } from '@/util/status-util'
const copyIcon = require('../images/copy_icon.png')
const openIcon = require('../images/open_icon.png')

export default {
    data() {
        return {
            active: 'home',
            pageId: this.$route.params.pageId,
            shareInfo: {},
            copyIcon,
            openIcon,
            isCustomLeft: false,
        }
    },
    created() {
        offStatus('loading')
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
        this.getShareInfo()
        // setTimeout(()=>{
        //     $CA.util.NativeAPI.invoke('hiddenCloseBtn',{"hiddenClose":"1"})
        // })
    },
    mixins: [mixin],
    mounted() {

    },
    methods: {
        getPageDetail() {
            return new Promise((resolve, reject) => {
                const data = {
                    tid: this.tid,
                    pageId: this.pageId,
                }
                Questionnaire.getQuestionDetail(data).then((res) => {
                    let { data: { data } } = res
                    resolve(data)
                })
            })
        },
        shareTo(key) {
            const { guaguaApp } = browser
            if (!guaguaApp) {
                Toast.fail('请在呱呱移动端分享')
                return
            }
            this.getPageDetail().then((pageInfo) => {
                const params = {
                    title: pageInfo.pageName,
                    content: pageInfo.pageComment,
                    shareUrl: this.shareInfo.shareUrl,
                    thumbImage: 'https://image1.guazistatic.com/qn210527174632f3547769bac16fa31b809e639ebf2518.png',
                }
                NativeApi.invoke(key, params)
            })
        },
        getShareInfo() {
            const data = {
                tid: this.tid,
                pageId: this.pageId,
            }
            Questionnaire.questionShare(data).then((res) => {
                if (res.data.code == 'S00000') {
                    this.shareInfo = res.data.data
                }
            }).catch((error) => {
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        copyUrl(copyUrl) {
            copy(copyUrl).then(() => {
                Toast.success({
                    message: '复制成功',
                    position: 'top',
                })
            }).catch((error) => {

                console.log('copy text error', error)
            })


        },
        turnTo(url) {
            this.$jump({
                path: url,
            }, 'href')
        },
    },
}
</script>
<style lang="scss" scoped>
    .wrap{
        position: relative;
        height: 100%;
        .me-card__card-box{
            margin: 10px auto;
            user-select: none;
            -webkit-user-select: none;
        }
        .operate{
            margin-top: 0.32rem;
            .me-button{
                margin-right: 10px;
                background: #f6f6f6;
                border: none;
                border-radius: 6px;
                color: #9298A8;
            }
            .me-icon{
                width: .48rem;
                height: .48rem;
                .me-icon__image{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .content{
            .qrcode-img{
                width: 120px;
                height: 120px;
                img{
                    width: 100%;
                }
            }
            .qrcode-tips{
                color: #5F6670;
                font-weight: normal;
                font-size: .4rem;
                margin-bottom: .32rem;
                p{
                    margin: 0;
                }
                .me-button{
                    margin: 0 10px;
                }
            }
        }

    }
    .share{
        >img{
            width: 1.28rem;
            height: 1.28rem;
        }
        .wexin{
            margin-left: .49rem;
        }
    }
    .title{
        margin-top: 0;
    }
    ::v-deep .me-cell{
        padding: 6px 12px;
        background-color: #F6F6F6;
        border-radius: 6px;
        &::after{
            border: none;
        }
    }
</style>
